<template>
  <div class="draggableContainer">
    <div
      v-for="(codeBaseForType, type) in codeBase"
      :key="type"
      >
      <Draggable
        v-for="(code, key) in codeBaseForType"
        :key="key"
        v-if="~customCodeInEditMode.indexOf(key)"
        :codeKey="key"
        :codeVal="code"
        :codeType="type"
        />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import Draggable from './Draggable'

export default {
  props: ['codeBase'],
  components: {
    Draggable
  },
  computed: {
    ...mapState([
      'customCodeInEditMode'
    ])
  }
}
</script>
